<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
    <v-container fluid full-height grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="assignDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="assignDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="shiftInfoList"
                  label="Shift Name"
                  v-model="shiftAssign.shiftInfoId"
                  item-text="name"
                  item-value="id"
                  :rules="[() => !!shiftAssign.shiftInfoId || 'Shift name is required',]"
                ></v-select>
              </v-flex>
              <v-flex sm12 v-if="shiftAssign.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shiftAssign.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="shiftAssign.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="shiftAssign.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="shiftAssign.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="shiftAssign.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addAssignDetail()">
                    Add Cashier
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex sm3>Cashier</v-flex>
                  <v-flex sm3>Counter</v-flex>
                  <v-flex sm3>Status</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(shiftAssignDetail, index) in shiftAssign.assignDetailList"
                  :key="index"
                >
                  <v-flex sm3>
                    <v-autocomplete
                      v-model="shiftAssignDetail.userId"
                      :loading="showAutocompleteLoading"
                      :items="userList"
                      label="Select cashier"
                      item-text="username"
                      item-value="id"
                      menu-props="auto"
                      @change="id => addUserId(index, id)"
                      :readonly="shiftAssignDetail.id?true:false"
                      :rules="[() => !!shiftAssignDetail.userId || 'Cashier is required',]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm3>
                    <v-autocomplete
                      v-model="shiftAssignDetail.counterId"
                      :loading="showAutocompleteLoading"
                      :items="counterList"
                      item-value="id"
                      item-text="name"
                      menu-props="auto"
                      @change="id => addCounterId(index, id)"
                      label="Select counter"
                      :rules="[() => !!shiftAssignDetail.counterId || 'Counter is required',]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm3 v-if="shiftAssignDetail.id">
                    <v-switch v-model="shiftAssignDetail.status"></v-switch>
                  </v-flex>
                  <v-flex sm3 v-if="!shiftAssignDetail.id">
                    <v-btn
                      icon
                      v-if="index === 0"
                      @click="removeAssignDetail(index,shiftAssignDetail)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn icon v-else @click="removeAssignDetail(index,shiftAssignDetail)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-btn color="success" @click="addAssignSalePerson()">
                    Add Saleperson
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex sm3>Saleperson</v-flex>
                  <v-flex sm3>Status</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(shiftAssignSalePerson, index) in shiftAssign.assignSalePersonList"
                  :key="index"
                >
                  <v-flex sm3>
                    <v-autocomplete
                      v-model="shiftAssignSalePerson.userId"
                      :loading="showAutocompleteLoading"
                      :items="salePersonList"
                      label="Select saleperson"
                      item-text="username"
                      item-value="id"
                      menu-props="auto"
                      @change="id => addSalePersonId(index, id)"
                      :readonly="shiftAssignSalePerson.id?true:false"
                      :rules="[() => !!shiftAssignSalePerson.userId || 'Saleperson is required',]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm3 v-if="shiftAssignSalePerson.id">
                    <v-switch v-model="shiftAssignSalePerson.status"></v-switch>
                  </v-flex>
                  <v-flex sm3 v-if="!shiftAssignSalePerson.id">
                    <v-btn
                      icon
                      v-if="index === 0"
                      @click="removeAssignSalePerson(index,shiftAssignSalePerson)"
                      disabled
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                    <v-btn icon v-else @click="removeAssignSalePerson(index,shiftAssignSalePerson)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" type="submit" :disabled="!valid">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { shiftAssignService } from "../../services/shift-assign-service";
import { shiftInfoService } from "../../services/shift-info-service";
import { userService } from "../../services/user-service";
import { counterService } from "../../services/counter-service";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import {
  ShiftAssign,
  ShiftAssignDetail,
  ShiftAssignSalePerson
} from "../../models/model";

export default {
  name: "ShiftAssignDetail",
  components: { VSwitch },
  data: () => ({
    breadcrumbs: [
      {
        text: "Shift Assign",
        disabled: false,
        to: "shift-assigns"
      },
      {
        text: "Shift Assign Detail",
        disabled: true
      }
    ],
    shiftAssign: new ShiftAssign(),
    oldShiftAssign: new ShiftAssign(),
    shiftAssignDetail: new ShiftAssignDetail(),
    shiftAssignSalePerson: new ShiftAssignSalePerson(),
    shiftInfoList: [],
    userList: [],
    salePersonList: [],
    counterList: [],
    showAutocompleteLoading: false,
    saveLoading: false,
    responseError: "",
    shopId: "",
    isEdit: false,
    valid: true,
    assignDate: ""
  }),
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    this.shopId = user.shopId;
    this.getUsersByShopId(this.shopId);
    this.getSalePersonsByShopId(this.shopId);
    this.getShiftInfosByShopId(this.shopId);
    this.getCountersByShopId(this.shopId);
    const id = this.$route.params.id;
    if (id == "new") {
      // new assign
      this.isEdit = false;
      this.assignDate = commonService.formatDate(new Date(), "YYYY-MM-DD");
      this.addAssignDetail();
      this.addAssignSalePerson();
    } else {
      this.getShiftAssignDetail(id);
      this.isEdit = true;
    }
  },
  methods: {
    getUsersByShopId(shopId) {
      userService
        .getUsersByShopId("SALE", shopId)
        .then(res => {
          this.userList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSalePersonsByShopId(shopId) {
      userService
        .getUsersByShopId("SALE_PERSON", shopId)
        .then(res => {
          this.salePersonList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getShiftInfosByShopId(shopId) {
      shiftInfoService
        .getShiftInfosByShopId(shopId)
        .then(res => {
          this.shiftInfoList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCountersByShopId(shopId) {
      counterService
        .getCountersByShopId(shopId)
        .then(res => {
          this.counterList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    addUserId(index, userId) {
      this.shiftAssign.assignDetailList[index].userId = userId;
    },
    addCounterId(index, counterId) {
      this.shiftAssign.assignDetailList[index].counterId = counterId;
    },
    addSalePersonId(index, userId) {
      this.shiftAssign.assignSalePersonList[index].userId = userId;
    },
    addAssignDetail() {
      //deep copy
      let shiftAssignDetail = new ShiftAssignDetail();
      this.shiftAssign.assignDetailList.push(shiftAssignDetail);
    },
    removeAssignDetail(index) {
      this.$delete(this.shiftAssign.assignDetailList, index);
    },
    addAssignSalePerson() {
      //deep copy
      let shiftAssignSalePerson = new ShiftAssignSalePerson();
      this.shiftAssign.assignSalePersonList.push(shiftAssignSalePerson);
    },
    removeAssignSalePerson(index) {
      this.$delete(this.shiftAssign.assignSalePersonList, index);
    },
    getShiftAssignDetail(id) {
      shiftAssignService
        .getShiftAssignDetail(id)

        .then(res => {
          this.shiftAssign = res.data;
          this.assignDate = commonService.millisecondToDate(
            this.shiftAssign.assignDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.formatDate(
            new Date(this.shiftAssign.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.shiftAssign.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldShiftAssign = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        // convert to millisecond
        this.shiftAssign.assignDateInMilliSeconds = commonService.convertToMilliseconds(
          this.assignDate
        );
        shiftAssignService
          .saveShiftAssign(this.shiftAssign)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.shiftAssign.id) {
        this.shiftAssign = new ShiftAssign();
        this.addAssignDetail();
        this.addAssignSalePerson();
      } else {
        const id = this.$route.params.id;
        this.getShiftAssignDetail(id);
      }
      this.responseError = "";
    },
    goBack() {
      this.$router.push("/shift-assigns");
    }
  }
};
</script>

<style scoped>
</style>